import React from 'react';
import Header from './components/Header';
import Social from './components/Social';
import About from './components/About';
import Accordions from './components/Accordions';
import TypeWriter from './components/TypeWriter';
import ImageSwiper from './components/ImageSwiper';
import Clients from './components/Clients';
import Share from './components/Share';
import Footer from './components/Footer';
import background from './images/bg.jpg';
import BottomSwiper from './components/BottomSwiper';

function App() {

  var domainUrl = 'https://miraperetz.netlify.app/'
  var businessName = 'מירה פרץ';
  var businessDescription = 'קליניקה לקוסמטיקה ויופי'
  var phoneNumber = '+972508552262'
  var email = 'Miraber1603@gmail.com'
  var facebookUrl = 'https://www.facebook.com/profile.php?id=100094618582406&mibextid=haYZDX'
  var instagram = 'miraperetz_cosmetics'
  var whatsapp = '+972508552262'
  var wazeUrl = 'https://www.waze.com/he/live-map/directions/il/%D7%9E%D7%97%D7%95%D7%96-%D7%94%D7%9E%D7%A8%D7%9B%D7%96/%D7%A4%D7%AA/%D7%A4%D7%95%D7%97%D7%A1-5?to=place.ChIJQ2I40no2HRURqPhav5G3PWQ'
  var days = " א' - ה'"
  var hours = '16:00 - 21:00'
  //קצת עליי
  //טיפולים בקליניקה
  //לקוחות ממליצים
  //icon
  //שם ותיאור


  const divStyle = {
    backgroundImage: `url(${background})`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
  };
  return (
    <div className="bg-gray-50 w-full">
      <div className=" md:w-4/5 lg:max-w-[1152px] mx-auto shadow-2xl">
        <div className="object-cover">
          <div style={divStyle}>
            <Header
              businessName={businessName}
              businessDescription={businessDescription} />

            <Social
              businessName={businessName}
              businessDescription={businessDescription}
              phoneNumber={phoneNumber}
              email={email}
              facebookUrl={facebookUrl}
              instagram={instagram}
              whatsapp={whatsapp}
              wazeUrl={wazeUrl}
              domainUrl={domainUrl}
            />
            <About />

            <Accordions
              phoneNumber={phoneNumber}
              email={email}
              days={days}
              hours={hours}
            />
            <TypeWriter
              businessName={businessName}
              businessDescription={businessDescription}
            />

          </div>
          <div style={divStyle}>
            <ImageSwiper />

            <BottomSwiper />

            <Clients
              whatsapp={whatsapp} />

            <Share domainUrl={domainUrl} />
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default App;
